export enum Types {
  START_INSTANCE = 'Start Environment',
  STOP_INSTANCE = 'Stop Environment',
  APPLY_RELEASE_PACKAGE = 'Apply Release Package',
  SOLUTION_REFRESH = 'Solution Upgrade'
}
